import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import type { PreventionListItemModel } from '../definitions/prevention-list-item.model';
import { FilterContainerModule } from '@ui/shared/ui-filter';

@Component({
    selector: 'ui-prevention-details-framework',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DetailViewModule, FilterContainerModule],
    templateUrl: './prevention-details-framework.component.html',
    styleUrls: ['./prevention-details-framework.component.scss'],
})
export class PreventionDetailsFrameworkComponent {
    public mapItem = input.required<PreventionListItemModel>();
}
